<template>
  <div class="verifyMainPage">
    <h4 class="spTit">审批</h4>
    <div class="buttonCodeBox clearfix">
      <span class="fl Htitle">审批状态：</span>
      <van-radio-group
        v-model="verifyData.buttonCode"
        direction="horizontal"
        class="clearfix radioBox fl"
      >
        <van-radio name="pass" @click="changeButtonCode('pass')" class="fl"
          >同意</van-radio
        >
        <van-radio name="reject" @click="changeButtonCode('reject')" class="fr"
          >不同意</van-radio
        >
        <van-radio name="hangup" @click="changeButtonCode('hangup')" class="fr"
          >标记</van-radio
        >
      </van-radio-group>
    </div>
    <van-cell-group
      class="baseNone baseSalary dwBox"
      v-if="
        fromInput &&
        routerName == 'reimbursement' &&
        verifyData.buttonCode == 'pass' &&
        editForm
      "
    >
      <div class="expensesTypeBox clearfix">
        <span class="fl title">类型：</span>
        <van-radio-group
          v-model="expensesType"
          required
          direction="horizontal"
          class="clearfix radioBox fl"
        >
          <van-radio name="1" @click="changeExpensesType('one')" class="fl"
            >销售费用</van-radio
          >
          <van-radio name="2" @click="changeExpensesType('two')" class="fr"
            >生产成本</van-radio
          >
        </van-radio-group>
      </div>

      <van-field
        v-model="paidAmount"
        clearable
        required
        class="ggInput"
        input-align="right"
        type="number"
        v-enterIntNumber
        label="税额（元）："
        placeholder="请输入...  "
      />
      <van-field
        v-model="agreedAmount"
        clearable
        required
        class="ggInput"
        input-align="right"
        type="number"
        v-enterIntNumber
        label="总额（元）："
        placeholder="请输入...  "
      />
    </van-cell-group>
    <!-- 挂起操作 -->
    <van-cell-group
      class="itemPerson baseNone moreText"
      v-if="verifyData.buttonCode == 'hangup'"
    >
      <van-field
        v-model="reasonTypeName"
        required
        readonly
        label="标记操作："
        placeholder="请选择"
        @click="checkReasonType"
        is-link
      />
    </van-cell-group>
    <van-cell-group
      class="baseNone beizhu"
      v-if="
        verifyData.buttonCode == 'reject' || verifyData.buttonCode == 'pass'
      "
    >
      <p>审批意见：</p>
      <van-field
        v-model="verifyData.message"
        @input="chnageMessage(verifyData.message)"
        rows="2"
        autosize
        :readonly="disType"
        :required="verifyData.buttonCode == 'reject' && disType"
        class="message"
        type="textarea"
        placeholder="请填写审批意见"
      />
    </van-cell-group>
    <div class="zgcBg" v-if="this.verifyType == '2'"></div>
    <div class="btnBox" v-if="verifyType == '1'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput()"
        >{{ btnText }}</van-button
      >
    </div>

    <!-- 弹出框 -->
    <!-- 时间控件 -->
    <van-popup v-model="reasonTypePicker" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        value-key="dictName"
        :columns="reasonTypeList"
        @confirm="onChangeReasonType"
        @cancel="reasonTypePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { dateFormat, getDictList, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "verifyMain",
  data() {
    return {
      keyWord: "",
      verifyType: "", //判断是否已审核
      disType: false, //是否可编辑
      verifySelectShow: false, //审批通不通过默认不显示
      fromInput: true,
      editForm: false,
      routerName: "",
      paidAmount: "", //税额
      agreedAmount: "", //总额
      expensesType: "", //费用类型
      expensesValue: "", //费用类型值
      applyMsg: {},
      btnText: "提交",
      reasonTypeList: [],
      reasonTypeName: "",
      reasonTypePicker: false,
      expensesTypePicker: false, //费用类型
      expensesTypeList: [], //费用类型码表
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      verifyData: {
        //传递的审批Data
        buttonCode: "pass", //审批状态
        data: {}, //附件对象
        buttonData: { reason: "" },
        message: "同意", //审批意见
      },
    };
  },
  props: {
    applicantData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    this.verifyType = this.$route.query.verifyType; //
    this.routerName = document.location.hash.substr(2, 13);
    if (this.applicantData && this.applicantData.workflowCode) {
      this.applyMsg = newApi.assign({}, this.applyMsg, this.applicantData);
      this.disType = this.verifyType == "1" ? false : true;
      this.getCurrentNode();
      this.getReasonTypeList();
    }
  },
  methods: {
    //流程当前节点信息
    getCurrentNode() {
      let _this = this;
      _this.$api.flowPath.flow
        .getCurrentNode(this.applyMsg.workflowCode)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            if (res.data.properties) {
              console.log(res.data, "res.data");
              _this.editForm = res.data.properties.editForm;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getReasonTypeList() {
      this.reasonTypeList = await getDictList("hangup"); //字典项接口获取资金用途
    },
    changeExpensesType(name) {
      if (name == "one") {
        this.expensesType = "1";
      } else {
        this.expensesType = "2";
      }
    },
    checkInput() {
      console.log(122222);

      if (this.routerName == "reimbursement" && this.editForm) {
        this.$set(this.verifyData.data, "paidAmount", this.paidAmount);
        this.$set(this.verifyData.data, "agreedAmount", this.agreedAmount);
        this.$set(this.verifyData.data, "expensesType", this.expensesType);
        if (
          this.verifyData.buttonCode &&
          this.verifyData.buttonCode == "pass" &&
          this.verifyData.message
        ) {
          if (
            this.verifyData.data.expensesType &&
            this.verifyData.data.paidAmount &&
            this.verifyData.data.agreedAmount
          ) {
            this.btnLoading = true;
            this.saveVerify();
          } else {
            this.$toast("带星号为必填项, 不能为空");
            this.btnLoading = false;
          }
        } else if (
          this.verifyData.buttonCode &&
          this.verifyData.buttonCode == "reject" &&
          this.verifyData.message
        ) {
          this.btnLoading = true;
          this.saveVerify();
        } else {
          if (this.verifyData.buttonCode == "hangup") {
            if (this.verifyData.buttonData.reason == "") {
              this.$toast("带星号为必填项, 不能为空");
            } else {
              this.btnLoading = true;
              this.saveGq();
            }
          } else {
            this.$toast("带星号为必填项, 不能为空");
            this.btnLoading = false;
          }
        }
      } else if (this.verifyData.buttonCode == "hangup") {
        if (this.verifyData.buttonData.reason == "") {
          this.$toast("带星号为必填项, 不能为空");
        } else {
          this.btnLoading = true;
          this.saveGq();
        }
      } else {
        if (this.verifyData.buttonCode == "" || this.verifyData.message == "") {
          this.$toast("带星号为必填项, 不能为空");
        } else {
          this.btnLoading = true;
          this.saveVerify();
        }
      }
    },
    //保存审批状态
    changeButtonCode(value) {
      if (value == "hangup") {
        this.verifyData.buttonCode = value;
        this.btnText = "标记";
      } else {
        this.btnText = "提交";
        this.verifyData.buttonCode = value;
        this.verifyData.message = value == "pass" ? "同意" : "不同意";
        if (value == "pass" && this.editForm) {
          this.fromInput = true;
        }
      }
    },
    chnageMessage(val) {
      this.verifyData.message = val;
    },
    checkReasonType() {
      this.reasonTypePicker = true;
    },
    //保存挂起的值
    onChangeReasonType(data) {
      console.log(data);
      this.reasonTypeName = data.dictName;
      this.$set(this.verifyData.buttonData, "reason", data.dictCode);
      this.reasonTypePicker = false;
    },
    saveGq() {
      //挂起操作
      let _this = this;
      this.$set(this.verifyData, "message", "");
      console.log(this.verifyData);
      _this.$api.flowPath.flow
        .gqAudit(_this.applyMsg.workflowCode, this.verifyData)
        .then((res) => {
          if (res.code == "1") {
            if (is_wei()) {
              _this.$toast("标记成功");
              this.$emit("changeVerifyType", "1");
            } else {
              let text = "标记成功";
              closePage(text);
            }
            // console.log(res.data);
            // let text = "标记成功";
            // closePage(text);
          } else {
            _this.$toast(res.msg);
            this.btnLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.btnLoading = false;
        });
    },
    saveVerify() {
      console.log(1111111);
      let _this = this;
      _this.$api.flowPath.flow
        .audit(_this.applyMsg.workflowCode, this.verifyData)
        .then((res) => {
          if (res.code == "1") {
            if (is_wei()) {
              _this.$toast("审批成功");
              this.$emit("changeVerifyType", "1");
            } else {
              console.log(res.data);
              let text = "提交审批成功";
              closePage(text);
            }
          } else {
            _this.$toast(res.msg);
            _this.btnLoading = true;
          }
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = true;
        });
    },
    checkFlow() {},
  },
  watch: {
    applicantData: {
      handler: function (val) {
        if (val && val.workflowCode) {
          this.applyMsg = newApi.assign({}, this.applyMsg, val);
          this.verifyType == "1"
            ? (this.disType = true)
            : (this.disType = false);
          this.getCurrentNode();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.verifyMainPage {
  width: 100%;
  min-height: 450px;
  padding-top: 45px;
  position: relative;
  .baseNone.itemPerson {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }

  .spTit {
    width: 100%;
    color: #333;
    text-align: center;
    position: absolute;
    top: 15px;
  }
  .zgcBg {
    width: 100%;
    height: 50px;
    position: absolute;
    top: 60px;
    left: 0;
  }
  p {
    font-size: 14px;
    padding: 0 16px;
    color: #333;
  }
  .ggInput.van-cell::after {
    content: none;
  }
  .ggInput {
    border-bottom: 1px solid #ebedf0;
  }
  .baseNone {
    .van-cell__title {
      span {
        font-size: 14px;
      }
    }
    .van-field__body {
      .van-field__control {
        color: #969799;
        font-size: 14px;
        text-indent: 2em;
      }
    }
  }
  .message.van-cell--required::before {
    top: -20px;
  }
  .baseNone.beizhu {
    padding-top: 8px;
    min-height: 45px;
    .van-field__body {
      .van-field__control {
        text-align: left;
      }
    }
  }
  .radioBox {
    padding: 0 16px;
    .van-radio {
      height: 45px;
      .van-radio__label {
        font-size: 14px;
        color: #969799;
        line-height: 16px;
      }
    }
  }
  .expensesTypeBox,
  .buttonCodeBox {
    border-bottom: 1px solid #ebedf0;

    // position: relative;
    span.title,
    span.Htitle {
      display: block;
      width: 90px;
      font-size: 14px;
      padding-left: 16px;
      color: #333;
      line-height: 45px;
    }
    span.title::before {
      position: absolute;
      left: 2.133vw;
      color: #ee0a24;
      font-size: 3.733vw;
      content: "*";
    }
  }
}
</style>